// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/animate.min.css
// module id = 420
// module chunks = 10